var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 6.24984H11.4587C12.4942 6.24984 13.3337 7.0893 13.3337 8.12484C13.3337 9.16037 12.4942 9.99984 11.4587 9.99984H7.91699H11.8753C12.9109 9.99984 13.7503 10.8393 13.7503 11.8748C13.7503 12.9104 12.9109 13.7498 11.8753 13.7498H7.91699M7.91699 6.24984H6.66699M7.91699 6.24984V13.7498M7.91699 13.7498H6.66699M8.33366 4.99984V6.24984M8.33366 13.7498V14.9998M10.8337 4.99984V6.24984M10.8337 13.7498V14.9998M18.3337 9.99984C18.3337 14.6022 14.6027 18.3332 10.0003 18.3332C5.39795 18.3332 1.66699 14.6022 1.66699 9.99984C1.66699 5.39746 5.39795 1.6665 10.0003 1.6665C14.6027 1.6665 18.3337 5.39746 18.3337 9.99984Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.dea3bb2c7dff54ae25469e300ea6b969.svg";
export { ForwardRef as ReactComponent };